import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4">
      <div className="w-full max-w-[400px] animate-fade-in">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-[#C5A059] text-white text-xl font-extrabold mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            BM
          </div>
          <h1 className="text-2xl font-bold text-[#0F172A]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Banks Morgan</h1>
          <p className="text-xs text-[#6B7280] uppercase tracking-[0.15em] mt-1 font-medium">Recruitment Hub</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-lg border border-[#E5E7EB] p-6 md:p-8">
          <h2 className="text-lg font-semibold text-[#0F172A] mb-1">Sign in</h2>
          <p className="text-sm text-[#6B7280] mb-6">Enter your credentials to access the platform</p>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700" data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-[#0F172A] text-sm font-medium">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 h-11 border-[#E5E7EB] focus:ring-2 focus:ring-[#0F172A] focus:border-transparent"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-[#0F172A] text-sm font-medium">Password</Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5 h-11 border-[#E5E7EB] focus:ring-2 focus:ring-[#0F172A] focus:border-transparent"
                data-testid="login-password-input"
              />
            </div>
            <div className="flex justify-end">
              <Link to="/hub/forgot-password" className="text-xs text-[#1E3A8A] hover:underline font-medium" data-testid="forgot-password-link">
                Forgot password?
              </Link>
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full h-11 bg-[#0F172A] hover:bg-[#1E293B] text-white font-medium transition-all duration-200"
              data-testid="login-submit-btn"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>

      </div>
    </div>
  );
}
